import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CourseCatalogApiService } from '../../services/course-catalog.api-service';
import { CourseCatalogOverview } from '../../models/course-catalog-overview.model';
import { CourseCatalogOverviewCategory } from '../../models/course-catalog-overview-category.model';
import { CourseCatalogService } from '../../services/course-catalog.service';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CourseCatalogCategoryType } from '../../enums/course-catalog-category-type.enum';

@Component({
    selector: 'app-course-catalog-preview',
    templateUrl: './course-catalog-preview.component.html',
    styleUrls: ['./course-catalog-preview.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CourseCatalogPreviewDialogComponent implements OnInit {
    @Input() catalogId!: string;

    courseCatalogLandingPageOverview!: CourseCatalogOverview;
    selectedCourseStructureCategoryId?: string;

    constructor(
        public dialogRef: MatDialogRef<CourseCatalogPreviewDialogComponent>,
        private _courseCatalogApiService: CourseCatalogApiService,
        private _courseCatalogService: CourseCatalogService,
        private cdr: ChangeDetectorRef
    ) {}

    async ngOnInit(): Promise<void> {
        this.courseCatalogLandingPageOverview = await this._courseCatalogApiService.getCatalogsOverview(this.catalogId).toPromise();

        this.courseCatalogLandingPageOverview.categories = this.courseCatalogLandingPageOverview.categories.map((cat) => ({
            ...cat,
            open: false,
            children: [],
            postingStream: [],
        }));

        await Promise.all(
            this.courseCatalogLandingPageOverview.categories.map(async (category) => {
                if (category.type === CourseCatalogCategoryType.UNINITIALIZED) {
                    category.postingStream = [];
                    return;
                }

                const postings = await firstValueFrom(
                    this._courseCatalogApiService.getCategoryPostingStream(category.id).pipe(catchError(() => of([])))
                );
                category.postingStream = postings;
            })
        );

        this.cdr.detectChanges();
    }

    showCourseCatalogLandingPageOverview(): void {
        this.selectedCourseStructureCategoryId = null;
    }

    async toggleCategory(category: CourseCatalogOverviewCategory): Promise<void> {
        category.open = !category.open;

        if (category.open && category.hasPublishedSubCategories && !category.children.length) {
            try {
                const children = await this._courseCatalogApiService.getCatalogsOverviewSubcategories(category.id).toPromise();

                category.children = children.map((child) => ({
                    ...child,
                    open: false,
                    children: [],
                }));
            } catch (err) {
                console.error(`Greška kod dohvata podkategorija za ${category.name}:`, err);
            }
        }

        this.cdr.detectChanges();
    }

    openCourseStructureCategory(category: CourseCatalogOverviewCategory): void {
        if (this.selectedCourseStructureCategoryId === category.id) {
            return;
        }

        this._courseCatalogService.setSelectedCategoryId(category.id);
        this.selectedCourseStructureCategoryId = category.id;
        this.cdr.detectChanges();
    }
}
